import { PaymentTermSchema, PlanStatusSchema } from '@weft/types';
import { ObjectIdSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const PlanOverviewSchema = oz.object({
  id: ObjectIdSchema,
  name: oz.string().nonempty(),
  revenue: oz.number().nonnegative(),
  accrued: oz.number().nonnegative(),
  paymentTerm: PaymentTermSchema,
  status: PlanStatusSchema,
  customersCount: oz.number().nonnegative(),
  basedFromPlanId: ObjectIdSchema.optional(),
}).openapi('PlanOverview');

export type PlanOverview = oz.infer<typeof PlanOverviewSchema>;